module.exports = __webpack_public_path__ + "img/Add Patient - Pink - Selected.dfa0fd01.png";